import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import DescriptionBox from '@/common/components/DescriptionBox/DescriptionBox'

import ActionConfigRenderer from './ActionConfigRenderer/ActionConfigRenderer'
import SelectedActionIcon from './SelectedActionIcon/SelectedActionIcon'
import { actionTypes } from './constants'
import { getAvailableActionTypeOptions, getDefaultConfigForAction } from './helpers'
import * as Styles from './styles'

const PolicyRuleActionEditor = ({
  actionType,
  actionConfig,
  onChange,
  onChangeConfig,
  disabled,
  currencyOptions,
  currencies,
  storeCurrencyCode,
  productTypes,
  productCategories,
  productCollections,
  errors = [],
  disabledActions = [],
  availableIssueRefundStatuses,
  availableIssueExchangeStatuses,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const availableOptions = getAvailableActionTypeOptions(disabledActions)

  const options = availableOptions.map(option => ({
    ...option,
    label: (
      <Styles.OptionLabel>
        <option.icon size={16} />
        {t(option.label)}
      </Styles.OptionLabel>
    ),
  }))

  const handleChangeActionType = value => {
    onChange({
      action_type: value,
      action_config: getDefaultConfigForAction(value),
    })
  }

  const description = actionTypes[actionType]?.description
  const hasActionTypeError = errors.some(e => e.type === 'actionTypeEmpty')

  return (
    <Styles.Container>
      <Text type="titleS">{t('Acción')}</Text>
      <Text type="bodyMRegular">
        {t('Define la acción que se aplicará si se cumplen las condiciones de la regla.')}
      </Text>
      <Styles.ActionAndDescriptionContainer>
        <ComboBox
          label={t('Tipo de acción')}
          menuItems={options}
          handleChange={e => handleChangeActionType(e.target.value)}
          value={actionType || ''}
          fullWidth
          disabled={disabled}
          startAdornment={actionType && <SelectedActionIcon actionType={actionType} />}
          backgroundColor={theme.colors.background.primary}
          error={hasActionTypeError}
          helperText={hasActionTypeError ? t('Este campo es obligatorio') : ' '}
        />
        {description && (
          <DescriptionBox>
            <Text type="bodyMRegular" color={theme.colors.text.muted}>
              {t(description)}
            </Text>
          </DescriptionBox>
        )}
      </Styles.ActionAndDescriptionContainer>
      <ActionConfigRenderer
        actionType={actionType}
        config={actionConfig}
        onChangeConfig={onChangeConfig}
        disabled={disabled}
        currencyOptions={currencyOptions}
        currencies={currencies}
        storeCurrencyCode={storeCurrencyCode}
        productTypes={productTypes}
        productCategories={productCategories}
        productCollections={productCollections}
        errors={errors}
        availableIssueRefundStatuses={availableIssueRefundStatuses}
        availableIssueExchangeStatuses={availableIssueExchangeStatuses}
      />
    </Styles.Container>
  )
}

export default PolicyRuleActionEditor
